<!-- 上传单图片 -->
<template>
  <file-upload accept=".jpeg,.jpg,.gif,.png,.webp,.ico" :multiple="true" :on-success="handleSuccess">
    <div v-if="!value || value === ''" class="upload flex-column flex flex-item-center flex-center">
      <i class="iconfont icon-plus"></i>
    </div>
    <img class="upload-image" v-else :src="value" />
  </file-upload>
</template>
<script>
import { defineComponent } from 'vue'
import fileUpload from '@/components/upload/file-upload.vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 'f-image',
  inheritAttrs: false,
  components: { fileUpload },
  props: { ...baseProps, modelValue: { type: String } },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    const { value, mySubmit } = controlItemManage(props, context)
    const handleSuccess = (res) => {
      mySubmit(res.data.url)
    }
    return {
      value,
      mySubmit,
      handleSuccess
    }
  }
})
</script>
<style lang="less" scoped>
.upload {
  width: 50px;
  height: 50px;
  border: 1px dashed #cdd0d6;
  background-color: #fafafa;
  font-size: 12px;
  color: #8c939d;
  margin-top: 8px;
  > i {
    font-size: 32px;
    color: #8c939d;
  }
}
.upload-image {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
</style>
